import { render, staticRenderFns } from "./HealthPro.vue?vue&type=template&id=b08175bc"
import script from "./HealthPro.vue?vue&type=script&lang=js"
export * from "./HealthPro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports